import * as React from 'react';
import classnames from 'classnames';
import { Progress } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import Button from '../Button/Button.js';

const InfinitePagination = ({ onClick , buttonLabel , total , loaded , isLoading , labelKey , className , pageNr: pagination ,  })=>{
    const { getFormattedLabel  } = useIntl();
    const label = labelKey && getFormattedLabel(labelKey, {
        labelData: {
            total,
            loaded: loaded > total ? total : loaded
        }
    });
    const href = `?page=${pagination ? pagination + 1 : 2}`;
    const clickHandler = (e)=>{
        e.preventDefault();
        onClick();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('infinite-pagination', className)
    }, /*#__PURE__*/ React.createElement(Progress, {
        id: "infinite-pagination-progress",
        label: label || '',
        value: loaded,
        max: total,
        className: "infinite-pagination__progress",
        "data-t": "progress-bar"
    }), loaded < total && /*#__PURE__*/ React.createElement(Button, {
        className: "infinite-pagination__button",
        "data-t": "pagination-load-more",
        caption: buttonLabel,
        href: href,
        onClick: clickHandler,
        variant: "outline",
        isLoading: isLoading
    }));
};
var InfinitePagination$1 = /*#__PURE__*/ React.memo(InfinitePagination);

export { InfinitePagination, InfinitePagination$1 as default };
//# sourceMappingURL=InfinitePagination.js.map
